import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import NPMVideo from '@rotaryintl/harris-video';

const Video = ({ sitecoreContext, params: { ComponentId } = {}, fields: { Src, Poster, FileName, children, Type } = {} }) => {
  const webDamURL = typeof Src.value === 'object' ? Src?.value.src : Src.value;
  const webDamPoster = typeof Poster.value === 'object' ? Poster?.value.url : Poster?.value;
  return (
    <NPMVideo
      name={FileName?.value}
      video={{
        src: webDamURL,
        poster: webDamPoster,
        controls: true,
        muted: true,
      }}
      sources={[
        {
          src: webDamURL,
          type: Type?.value || 'video/mp4',
        },
      ]}
      tracks={children?.map(({ fields: { Src, SrcLang, Kind, Label } }) => ({
        src: Src?.value,
        srcLang: SrcLang?.value,
        kind: Kind?.value,
        label: Label?.value,
      }))}
    />
  );
};

export default withSitecoreContext()(Video);
